module.exports = __webpack_public_path__ + "static/img/rico.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coaches/rico.jpg
// module id = Vwo/
// module chunks = 0